import React from 'react';
import PreviewPlayerCard from '../../PreviewPlayerCard';
import PreviewEditorCard from '../PreviewEditorCard';
import useFlags from '@jenmusic/feature-flag';
import RecordingConfirm from '../FileUploadCard/RecordingConfirm';

interface MusicUploadPreviewProps {
  hide?: () => void;
}

const MusicUploadPreview: React.FC<MusicUploadPreviewProps> = ({ hide }) => {
  const { showNewGenerator } = useFlags();

  if (showNewGenerator) {
    return (
      <div>
        <RecordingConfirm showButtons={false} hide={hide} />
      </div>
    );
  }

  return (
    <div>
      <PreviewPlayerCard />
      <PreviewEditorCard />
    </div>
  );
};

export default MusicUploadPreview;
